import './App.css';
import { Route, Routes } from 'react-router-dom';
import Login    from './pages/sesiones/Login';
import Register from './pages/sesiones/Register';
import Layout from './features/layouts/Layout';
import BusquedaTurnos from './pages/pacientes/BusquedaTurnos';
import PacienteDashboard from './pages/pacientes/PacienteDashboard';
import PreseleccionTurnos from './pages/pacientes/PreseleccionTurnos';
import MedicoDashboard from './pages/medicos/MedicoDashboard';
import Home from './pages/home/Home';
import { AuthProvider } from './context/auth/AuthContext';
import { NotificationProvider } from './context/auth/NotificationContext';
import TurnoLayout from './features/layouts/TurnoLayout';
import NotificationsPage from './pages/NotificationsPage';
import MedicoTurnoLayout from './features/layouts/MedicoTurnoLayout';
import MedicoTurnos from './pages/medicos/MedicoTurnos';
import HomeRoute from './features/HomeRoute';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Routes>
          <Route path='/' element={<Layout />}>
            <Route index element={<HomeRoute />} />
            
            <Route path='login' element={<Login />} />
            <Route path='register' element={<Register />} />

            <Route path='home' element={<Home />} />

            <Route path='paciente' element={<ProtectedRoute rolRequerido="Paciente" />}>
              <Route element={<TurnoLayout />}>
                <Route index element={<PacienteDashboard />} />
                <Route path='busqueda' element={<BusquedaTurnos />} />
                <Route path='preseleccion' element={<PreseleccionTurnos />} />
              </Route>
            </Route>

            <Route path='medico' element={<ProtectedRoute rolRequerido="Medico" />}>
              <Route element={<MedicoTurnoLayout />}>
                <Route index element={<MedicoDashboard />} />
                <Route path='turnos' element={<MedicoTurnos />} />
              </Route>
            </Route>
            <Route path='notificaciones' element={<NotificationsPage />} />
          </Route>
        </Routes>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
